export default __webpack_public_path__ + "static/media/percent-width.b2ad931b.jpg";